import { Component, OnInit, Output, EventEmitter, OnDestroy, computed, inject } from '@angular/core';
import { appReducer, profileSelectors, profileActions, userSelectors, userActions } from '@app-root-store';
import { Store, select } from '@ngrx/store';
import { IUser } from '@app-root-interfaces';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { EUserRole } from '@app-root-enums';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { IProfile } from '@scf-monorepo/interfaces';
import { AuthService } from '../../root-services/auth.service';

@Component({
    selector: 'app-header-profile-selector',
    templateUrl: './header-profile-selector.component.html',
    styleUrls: ['./header-profile-selector.component.scss'],
    standalone: false
})
export class HeaderProfileSelectorComponent implements OnInit, OnDestroy {
    private store$ = inject<Store<appReducer.AppState>>(Store);
    private router = inject(Router);

    @Output() menuClose = new EventEmitter<boolean>();

    public userProfile$: Observable<IProfile> = this.store$.pipe(select(profileSelectors.selectProfileUserProfile));
    public profiles$: Observable<IProfile[]> = this.store$.pipe(select(profileSelectors.selectProfileProfiles));
    public currentUser$: Observable<IUser> = this.store$.pipe(select(userSelectors.selectUserCurrentUser));

    public isAdmin$: Observable<boolean> = this.store$.pipe(select(userSelectors.selectUserIsAdmin));

    public selectedProfile$ = this.store$.pipe(select(profileSelectors.selectProfileSelectedProfile));

    public userRoles = EUserRole;
    public currentProfileId: string;
    private readonly authService = inject(AuthService);
    public userPhotoUrl = computed(() => this.authService.getUserPhotoUrl());
    private destroy$: Subject<boolean> = new Subject<boolean>();

    ngOnInit() {
        this.setData();
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    private setData() {
        this.selectedProfile$
            .pipe(
                filter((profile) => !!profile),
                tap((profile) => (this.currentProfileId = profile.id)),
                takeUntil(this.destroy$)
            )
            .subscribe();
    }

    public isAdminChanged(event: Event) {
        const checked = (event.target as HTMLInputElement).checked;
        this.store$.dispatch(userActions.setIsAdmin({ isAdmin: checked }));
        if (checked) {
            this.router.navigate(['main', 'drives']);
        } else {
            this.router.navigate(['main', 'my-unit']);
        }
    }

    public selectProfile(profile: IProfile) {
        const id: string = profile.id;
        this.store$.dispatch(profileActions.selectProfile({ id }));
        this.closeMenu();
    }

    public closeMenu() {
        this.menuClose.emit(true);
    }
}
